export default __webpack_public_path__ + "media/images/mailer/wordmark-97228b0df3e7d23f91de5ae254e85641.png";